import {
  type AutoReplyReport,
  AutoReplyReportSchema,
  AutoReplySettingsSchema,
  type DraftShadowReport,
  DraftShadowReportSchema,
  type UpdateAutoReplyGlobal,
  type UpdateAutoReplyTopic,
} from '@sbc/domain-models/gateway';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiGet, apiSend } from './client';

const DRAFT_SHADOW_KEY = ['admin', 'draft-shadow'];
const AUTO_REPLY_KEY = [...DRAFT_SHADOW_KEY, 'auto-reply'];

export function useDraftShadowReport(days: number) {
  return useQuery<DraftShadowReport>({
    queryKey: [...DRAFT_SHADOW_KEY, days],
    queryFn: () => apiGet(`/api/admin/draft-shadow?days=${days}`, DraftShadowReportSchema),
  });
}

export function useAutoReplyReport(days: number) {
  return useQuery<AutoReplyReport>({
    queryKey: [...AUTO_REPLY_KEY, days],
    queryFn: () => apiGet(`/api/admin/draft-shadow/auto-reply?days=${days}`, AutoReplyReportSchema),
  });
}

export function useUpdateAutoReplyGlobal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateAutoReplyGlobal) =>
      apiSend('PUT', '/api/admin/draft-shadow/auto-reply/global', input, AutoReplySettingsSchema),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTO_REPLY_KEY }),
  });
}

export function useUpdateAutoReplyTopic() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateAutoReplyTopic) =>
      apiSend('PUT', '/api/admin/draft-shadow/auto-reply/topic', input, AutoReplySettingsSchema),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTO_REPLY_KEY }),
  });
}
